"use client";

import { Tooltip as TooltipPrimitive } from "radix-ui";

/** Existing mobile menu uses the Provider as a non-visual wrapper. */
export const TooltipProvider = TooltipPrimitive.Provider;
